import { env } from "@/lib/env"
import type { CodeResponse, GroupedCodeValues } from "@/types/code-values"

export const codeService = {
  async getRawCodeValues(token: string | null): Promise<CodeResponse> {
    if (!token) {
      throw new Error("Authentication token is required to fetch code values")
    }

    const apiUrl = `${env.fboApiUrl}/api/code`
    const response = await fetch(apiUrl, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    })

    if (!response.ok) {
      throw new Error(`HTTP error ${response.status}: ${response.statusText}`)
    }

    return response.json()
  },

  async getCodeValues(token: string | null): Promise<GroupedCodeValues> {
    const response = await codeService.getRawCodeValues(token)
    const grouped: GroupedCodeValues = {}

    if (response.Items && Array.isArray(response.Items)) {
      response.Items.forEach((item) => {
        if (!grouped[item.groupName]) {
          grouped[item.groupName] = []
        }
        grouped[item.groupName].push(item)
      })

      Object.keys(grouped).forEach((groupName) => {
        grouped[groupName].sort((a, b) => a.sortOrder - b.sortOrder)
      })
    }

    return grouped
  },
}
